module.exports = __webpack_public_path__ + "static/img-1-mobile-bf3873b3ac64ddc9c1bf45d0f79649e2.jpg";